import React from "react";
import AdminBrandsMP from "./AdminBrandsMP";

export default function AdminDashBoard() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          marginTop: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        Dashboard
      </a>
      <AdminBrandsMP />
    </div>
  );
}
